import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BookOpen, Library, ScrollText, Sparkles } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/", label: "Daily Word", icon: BookOpen },
  { to: "/daily-devotional", label: "Devotional", icon: Sparkles },
  { to: "/turah-commands", label: "Turah Commands", icon: ScrollText },
];

export default function ScriptureHubNav({ currentDayOfYear }) {
  const location = useLocation();
  const { user } = useAuth();

  return (
    <nav className="border-b border-slate-200 bg-white" aria-label="Scripture library navigation">
      <div className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-3 py-2 sm:px-6">
        {items.map(({ to, label, icon: Icon }) => {
          const target = label === "Devotional" && currentDayOfYear ? `/daily-devotional/${currentDayOfYear}` : to;
          const active = label === "Daily Word"
            ? location.pathname === "/"
            : location.pathname.startsWith(to);
          return (
            <Link
              key={label}
              to={target}
              className={`inline-flex min-h-10 shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold ${active ? "bg-royal-blue text-white" : "text-slate-700 hover:bg-slate-100"}`}
            >
              <Icon className="h-4 w-4" />
              {label}
            </Link>
          );
        })}

        <Link
          to={user ? "/my-library" : "/login?next=/my-library"}
          className={`ml-auto inline-flex min-h-10 shrink-0 items-center gap-2 rounded-md px-3 py-2 text-sm font-semibold ${location.pathname.startsWith("/my-library") ? "bg-kingdom-gold text-royal-blue" : "border border-kingdom-gold text-royal-blue hover:bg-kingdom-gold/10"}`}
        >
          <Library className="h-4 w-4" />
          My Library
        </Link>
      </div>
    </nav>
  );
}
